import React from 'react';
import { Form, Select } from 'antd';
import { ErrorHandler } from '@common/components';
import { useQuery } from '@common/hooks';
import { ENUM_QUERY } from '@common/graphql';
import { FormLabelAlign } from 'antd/lib/form/interface';
import { selectInputFilterHelper } from '@common/services';

export function ShiftTypesSelectInput(props: {
  className: string;
  labelAlign: FormLabelAlign;
  labelCol: { span: number };
  wrapperCol: { span: number };
}) {
  const { loading, error, data } = useQuery(ENUM_QUERY, {
    variables: { key: 'WorksShiftType' },
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="ShiftTypesSelectInput"
        messageType="contextual"
      />
    );
  }

  return (
    <Form.Item
      name="shiftType"
      label="Shift"
      rules={[
        {
          required: true,
          message: 'Please enter the shift type value',
        },
      ]}
      {...props}
    >
      <Select
        showSearch
        loading={loading}
        filterOption={selectInputFilterHelper}
        placeholder="Select a Shift Type..."
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {data?.enum.map(({ name, description }) => (
          <Select.Option key={name} value={name}>
            {description}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}
